'use strict';

angular.module('mobile-apps')
	.directive('screenshotInfo',['TagMain', function(TagMain) {
		return {
			scope:
			{
				data: '=',
				popoverPlacement: '@'
			},
			templateUrl: 'modules/mobile-apps/views/screenshot-info.client.directive.html',

			link: function (scope, elem, attrs) {
				scope.TagMain = TagMain;
			}
		};
	}]);
